import { createContext } from 'react';

interface IDashboardContext {
  isDashboardCollapsed?: boolean;
  setIsDashboardCollapsed: (v: boolean) => void;
}

const initialValue: IDashboardContext = {
  setIsDashboardCollapsed: (isCollapsed: boolean) => {
    return isCollapsed;
  },
};

const DashboardContext = createContext<IDashboardContext>(initialValue);

export default DashboardContext;
